<template>
    <div class="status-bar">
        <div class="status-bar--item">
            <div class="status-bar--icon" :style="{ backgroundImage: 'url(' + require('@/assets/icon-chat.svg') + ')' }"></div>
            <span class="status-bar--title">{{ $t('message') }}</span>
        </div>
        <div class="status-bar--item">
            <div
                    @click="$emit('close', $event.target.value)"
                    class="status-bar--icon button"
                    :style="{ backgroundImage: 'url(' + require('@/assets/close-button.svg') + ')' }">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'StatusBar'
}
</script>

<style lang="scss">
.status-bar {
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #b7ceeb;
    cursor: move;
    .status-bar--item {
        display: flex;
        align-items: center;
        .status-bar--icon {
            width: 24px;
            height: 24px;
            background-repeat: no-repeat;
            background-size: cover;
            margin: 4px;
        }
        .status-bar--title {
            color: #fff;
        }
    }
    .button {
        cursor: pointer;
    }
}
</style>
